import { render, staticRenderFns } from "./V.vue?vue&type=template&id=532bd8d6&"
import script from "./V.vue?vue&type=script&lang=js&"
export * from "./V.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports